import * as ActionTypes from './actionTypes';
import * as MessageActions from '../../common/messageBox/actions/actions';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const loadOrigins = () =>
  apiActionCreator({
    'endpoint': '/origins',
    'authenticated': true,
    'types': [
      ActionTypes.LOAD_ORIGINS_REQUEST,
      ActionTypes.LOAD_ORIGINS_SUCCESS,
      [ActionTypes.LOAD_ORIGINS_FAILED, (error) => buildErrorMessage(error)],
    ],
    'microservice': 'part',
    'method': 'GET',
  });

export const addOrigin = (data) =>
  apiActionCreator({
    'endpoint': '/origins',
    'authenticated': true,
    'types': [
      ActionTypes.SUBMIT_NEW_ORIGIN_REQUEST,
      [
        ActionTypes.SUBMIT_NEW_ORIGIN_SUCCESS,
        MessageActions.addMessageBoxInfo('Origen añadido satisfactoriamente'),
      ],
      [
        ActionTypes.SUBMIT_NEW_ORIGIN_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'POST',
    'contentType': 'application/json',
    'data': data,
  });

export const editOrigin = (code, data) =>
  apiActionCreator({
    'endpoint': `/origins/${code}`,
    'authenticated': true,
    'types': [
      ActionTypes.SUBMIT_EDIT_ORIGIN_REQUEST,
      [
        ActionTypes.SUBMIT_EDIT_ORIGIN_SUCCESS,
        MessageActions.addMessageBoxInfo(
          'Origen actualizado satisfactoriamente'
        ),
      ],
      [
        ActionTypes.SUBMIT_EDIT_ORIGIN_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'PUT',
    'contentType': 'application/json',
    'data': data,
  });

export const initializeOriginData = (data) => ({
  'type': ActionTypes.INITIALIZE_ORIGIN_DATA,
  'payload': data,
});

export const filterOrigins = (value) => ({
  'type': ActionTypes.FILTER_ORIGINS,
  'payload': value,
});

export const changeOriginTextFilter = (value) => ({
  'type': ActionTypes.CHANGE_ORIGIN_TEXT_FILTER,
  'payload': value,
});
